import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  isDesktopViewport,
  useSearchOverlay,
  type SearchScope,
} from "@/components/layout/search-overlay-context";

/**
 * Returns a click handler for search entry points across the app. Desktop
 * opens the shared SearchOverlay with the given scope; mobile navigates to
 * a fallback page (typically the /search full page for workspace scope, or
 * the current page for scoped searches — the caller decides).
 *
 * Scope defaults to workspace, which is what the rail Search icon uses. In-
 * project / in-folder buttons pass their own scope.
 */
export function useSearchTrigger(mobileHref: string, scope: SearchScope = { kind: "workspace" }) {
  const navigate = useNavigate();
  const { openWith } = useSearchOverlay();
  return useCallback(() => {
    if (isDesktopViewport()) {
      openWith(scope);
    } else {
      navigate(mobileHref);
    }
  }, [openWith, navigate, mobileHref, scope]);
}
